// material-ui
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { ImageScore } from 'types/components/shared';
import { useIntl } from 'react-intl';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

// ===========================|| DATA WIDGET - PROJECT TABLE CARD ||=========================== //

const SpectsImages = ({ product }: { product: any }) => {
    const intl = useIntl();
    const theme = useTheme();
    return (
        <>
            {product ? (
                <>
                    <Table sx={{ width: '100%' }}>
                        <TableHead>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell> {intl.formatMessage({ id: 'aspects_to_evaluate' })} </TableCell>
                                <TableCell>{intl.formatMessage({ id: 'complete' })}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableRow sx={{ ml: 3 }}>
                            <TableCell>{intl.formatMessage({ id: 'dimensions' })}</TableCell>
                            <TableCell>
                                {product?.imageScore?.dimensionScore ? (
                                    <CheckCircleIcon color="success" />
                                ) : (
                                    <DoNotDisturbOnIcon color="error" />
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ ml: 3 }}>
                            <TableCell>{intl.formatMessage({ id: 'image_quality' })}</TableCell>
                            <TableCell>
                                {product?.imageScore?.qualityScore ? (
                                    <CheckCircleIcon color="success" />
                                ) : (
                                    <DoNotDisturbOnIcon color="error" />
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ ml: 3 }}>
                            <TableCell>{intl.formatMessage({ id: 'images_quantity' })}</TableCell>
                            <TableCell>
                                {product?.imageScore?.quantityScore ? (
                                    <CheckCircleIcon color="success" />
                                ) : (
                                    <DoNotDisturbOnIcon color="error" />
                                )}
                            </TableCell>
                        </TableRow>
                    </Table>
                    <TableContainer sx={{ maxHeight: '100%', bgcolor: 'background.paper' }}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{intl.formatMessage({ id: 'images' })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: 'caracteristics' })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {product?.imageDetailScore?.map((detail: ImageScore) => (
                                                <TableRow>
                                                    <TableCell>
                                                        {detail?.url !== '' ? (
                                                            <img
                                                                src={detail.url}
                                                                alt={intl.formatMessage({ id: 'image' })}
                                                                width="150"
                                                                height="150"
                                                            />
                                                        ) : (
                                                            <ImageNotSupportedIcon
                                                                sx={{
                                                                    background:
                                                                        theme.palette.mode === 'dark'
                                                                            ? theme.palette.dark.main
                                                                            : theme.palette.grey[50],
                                                                    width: 150,
                                                                    height: 150
                                                                }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <TableRow>
                                                            <TableRow>
                                                                <TableCell>{intl.formatMessage({ id: 'dimensions' })}: </TableCell>
                                                                <TableCell>
                                                                    {detail.dimensionScore ? (
                                                                        <CheckCircleIcon color="success" />
                                                                    ) : (
                                                                        <DoNotDisturbOnIcon color="error" />
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{intl.formatMessage({ id: 'size' })}:</TableCell>{' '}
                                                                <TableCell>{detail.imgSize}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{intl.formatMessage({ id: 'quality' })}:</TableCell>{' '}
                                                                <TableCell>{detail.imgQuality}</TableCell>
                                                            </TableRow>
                                                        </TableRow>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <p>Cargando ..</p>
            )}
        </>
    );
};

export default SpectsImages;
